// @ts-nocheck
import { createSelector } from "reselect";
import moment from "moment";
import { ListFieldsKeys, listFields, ListFieldsRecordType } from "src/api/config";
import { RootState } from "src/store/rootReducer";
import { FIELDS_TYPES } from "src/api/config/type.config";

const getObj = <K extends ListFieldsKeys>(
  state: RootState,
  listName: K,
  ID?: number
): Record<number, ListFieldsRecordType[K]> => {
  if (state.spitems.elements.obj && state.spitems.elements.obj[listName] && ID) {
    const obj = state.spitems.elements.obj[listName];
    if (Object.keys(obj).length !== 0 && obj && obj[ID]) {
      return obj[ID];
    }
  }
  if (!ID) {
    return state.spitems.elements.item[listName] || {};
  }
  return {};
};

const getFields = <K extends ListFieldsKeys>(state: RootState, listName: K) => {
  return listFields[listName];
};

export const selectItem = createSelector([getObj, getFields], (item, fields) => {
  if (item) {
    let obj: any = {};
    Object.keys(item).forEach((key) => {
      switch (fields[key]) {
        case FIELDS_TYPES.STRING:
        case FIELDS_TYPES.NUMBER:
        case FIELDS_TYPES.ID:
        case FIELDS_TYPES.CHOICE:
        case FIELDS_TYPES.JSON:
          obj = { ...obj, [key]: item[key] };
          break;
        case FIELDS_TYPES.DATE:
          if (item[key]) obj = { ...obj, [key]: moment(item[key]) };
          else obj = { ...obj, [key]: null };
          break;
        case FIELDS_TYPES.LOOKUP:
          obj = {
            ...obj,
            [key]: item[key] && {
              Title: item[key].get_lookupValue(),
              ID: item[key].get_lookupId(),
              Metadata: item[key].get_metadata ? item[key].get_metadata() : null,
            },
          };
          break;
        case FIELDS_TYPES.MULTI_LOOKUP:
          obj = {
            ...obj,
            [key]:
              (item[key as keyof typeof fields] as any) &&
              item[key as keyof typeof fields].length > 0 &&
              item[key as keyof typeof fields].map((elem: any) => {
                return {
                  Title: elem.get_lookupValue(),
                  ID: elem.get_lookupId(),
                  Metadata: elem.get_metadata ? elem.get_metadata() : null,
                };
              }),
          };
          break;
        case FIELDS_TYPES.MEDIA:
          obj = {
            ...obj,
            [key]: item[key] && item[key].get_url(),
          };
          break;
        case FIELDS_TYPES.LINK:
          obj = {
            ...obj,
            [key]: item[key] && item[key].get_url(),
          };
          break;
        case FIELDS_TYPES.USER:
          obj = {
            ...obj,
            [key]: item[key] && {
              Name: item[key].get_lookupValue && item[key].get_lookupValue() || item[key]['Name'] || null,
              ID: item[key].get_lookupId && item[key].get_lookupId() || item[key]['id'] || null,
              Email: item[key].get_email && item[key].get_email().toLowerCase().trim() || item[key]['email'] && item[key]['email'].toLowerCase().trim() || null,
              Metadata: item[key].get_metadata ? item[key].get_metadata() : null,
            },
          };
          break;
        case FIELDS_TYPES.MULTI_USER:
          obj = {
            ...obj,
            [key]:
              (item[key as keyof typeof fields] as any) &&
              item[key as keyof typeof fields].length > 0 &&
              item[key as keyof typeof fields].map((elem: any) => {
                return {
                  Name: elem.get_lookupValue(),
                  ID: elem.get_lookupId(),
                  Email: elem.get_email() && elem.get_email().toLowerCase(),
                  Metadata: elem.get_metadata ? elem.get_metadata() : null,
                };
              }),
          };
          break;
        case FIELDS_TYPES.MULTI_STRING:
          obj = {
            ...obj,
            [key]: item[key as keyof typeof fields],
          };
          break;
        case FIELDS_TYPES.MULTI_STRING_AND:
          obj = {
            ...obj,
            [key]: item[key as keyof typeof fields],
          };
          break;
        case FIELDS_TYPES.BOOLEAN:
          obj = { ...obj, [key]: !!item[key] };
          break;
        default:
          break;
      }
    });
    return obj;
  } else {
    return null;
  }
});
